/**
 * v-backdrop-close — 팝업 바깥(배경)을 눌러 닫기.
 *
 *  왜 @click.self 로는 안 되는가
 *   click 은 mousedown 과 mouseup 의 '공통 조상'에서 일어난다.
 *   팝업 안 입력칸에서 글자를 끌어 고르다가 배경에서 손을 떼면 그 공통 조상이 배경이 되어,
 *   click 의 타깃이 배경 = .self 조건 통과 = 닫히지 않아야 할 때 닫힌다.
 *   고치던 내용이 그대로 날아가므로 입력이 있는 팝업에서는 특히 나쁘다.
 *
 *  그래서 mousedown 과 mouseup 을 함께 본다 — 누르기 시작한 곳도 배경이어야 닫는다.
 *  배경을 그냥 클릭해서 닫는 동작은 그대로다.
 *
 *  쓰는 법 (배경 element 에)
 *    <div class="modal-backdrop" v-backdrop-close="close">          닫는 함수를 그대로
 *    <div class="modal-backdrop" v-backdrop-close="() => (open = false)">
 */
const DOWN = Symbol('backdropDown');
const UP = Symbol('backdropUp');
const FN = Symbol('backdropFn');

export default {
  mounted(el, binding) {
    el[FN] = binding.value;
    el[DOWN] = (e) => { el.__backdropStarted = e.target === el; };
    el[UP] = (e) => {
      const close = el.__backdropStarted && e.target === el;
      el.__backdropStarted = false;
      // 왼쪽 버튼으로 누른 것만 — 오른쪽 클릭(맥락 메뉴)으로 닫히면 곤란하다
      if (close && e.button === 0) el[FN]?.(e);
    };
    el.addEventListener('mousedown', el[DOWN]);
    el.addEventListener('mouseup', el[UP]);
  },
  // 닫는 함수가 바뀌면 최신 것을 쓴다(핸들러는 그대로 두고 참조만 갈아끼운다)
  updated(el, binding) { el[FN] = binding.value; },
  unmounted(el) {
    el.removeEventListener('mousedown', el[DOWN]);
    el.removeEventListener('mouseup', el[UP]);
    el[FN] = null;
  },
};
